








































// 以下代码复制于原本的登录逻辑 如果原本的登录逻辑有变 这里也需要同步过来
// 以下代码复制于原本的登录逻辑 如果原本的登录逻辑有变 这里也需要同步过来
// 以下代码复制于原本的登录逻辑 如果原本的登录逻辑有变 这里也需要同步过来
// 以下代码复制于原本的登录逻辑 如果原本的登录逻辑有变 这里也需要同步过来
// 以下代码复制于原本的登录逻辑 如果原本的登录逻辑有变 这里也需要同步过来
// 以下代码复制于原本的登录逻辑 如果原本的登录逻辑有变 这里也需要同步过来

import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import addRoutes from "@root/lib/addRoutes";
import router from "@root/router";
import { gql } from "graphql-tag";
import {
  createApolloClient,
  createPresetApolloClientOptions
} from "@gtech/preset-apollo-client";
import { login } from "@root/graphql/Login.gql";
import { gqlClient as selfGraphqlClient } from "@root/apollo/apollo-options";

localStorage.clear();

let AUTH_TOKEN;

const apolloClient = createApolloClient(
  createPresetApolloClientOptions({
    uri: (window as any).__GTECH_VARIABLES_MAIN_APP_GRAPHQL_URL__,
    setContextHeaders(headers) {
      headers["AUTH-TOKEN"] = AUTH_TOKEN;
    }
  })
);

const loginVuex = namespace("login");

const Root = namespace("root");
@Component({})
export default class User extends Vue {
  ruleForm: any = {
    account: "CKH0871017",
    password: "123456"
  };
  rules: any = {
    account: [{ required: true, message: "用户名不能为空" }],
    password: [{ required: true, message: "密码不能为空" }]
  };
  loading: boolean = false;
  passwordType: boolean = true;
  timer: any = null;
  @loginVuex.Action getTenanList;
  @loginVuex.Action login;
  @Root.Action menuListByRole;
  mounted() {
    localStorage.removeItem("menuList");
  }
  async handleSubmit() {
    try {
      this.loading = true;
      await this.handleVaild();
      await this.onLogin();

      await this.loginByAuthCode();

      const menuList = await this.menuListByRole();

      if (menuList && menuList.length) {
        addRoutes(router);
      }

      this.$router.push("/login");
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  }
  async handleVaild() {
    return new Promise((resolve, reject) => {
      const $form: any = this.$refs["ruleForm"];
      $form.validate(valid => {
        valid ? resolve("") : reject("表单验证错误");
      });
    });
  }
  async onLogin() {
    // 这里的逻辑来自于 原先的登录逻辑 这里只是搬运
    let {
      data: {
        login: { optionalTenants, ...other }
      }
    } = await apolloClient.query({
      query: login,
      variables: {
        identity: { ...this.ruleForm, type: "OP", tenantCode: "100007" }
      }
    });

    const userInfos = { ...other };
    let { userAuthToken } = userInfos;
    // localStorage.setItem("AuthToken", userAuthToken);
    localStorage.setItem("userInfo", JSON.stringify(userInfos));
    localStorage.setItem("org", "default");

    localStorage.setItem("account", this.ruleForm.account);

    // 新增的逻辑
    AUTH_TOKEN = userAuthToken;
  }
  async queryTenanList() {
    await this.getTenanList();
  }
  triggerPassword() {
    this.passwordType = !this.passwordType;
  }

  // token 交换 token
  // 这里是新增的逻辑
  async loginByAuthCode() {
    const appCode = (window as any).__GTECH_VARIABLES_APP_CODE__;

    // get auth code
    const {
      data: {
        getAuthCode: { code: authCode }
      }
    } = await apolloClient.query({
      query: gql`
          query getauthcode {
            getAuthCode(appCode: "${appCode}") {
              code
            }
          }
        `
    });

    // login by auth code
    let {
      data: {
        loginByAuthCode: { userAuthToken }
      }
    } = await selfGraphqlClient.query({
      query: gql`
        query loginByAuthCode($authCode: String!) {
          loginByAuthCode(authCode: $authCode) {
            userAuthToken
            userCode
            email
            firstName
            lastName
            mobile
            orgCode
            userType
            passwordSet
            tenantCode
            tenantName
          }
        }
      `,
      variables: {
        authCode
      }
    });

    localStorage.setItem("AuthToken", userAuthToken);
  }
}
